export const PLACEMENT_DRAWER_WORKSPACE = 'placement_drawer_workspace';
export const PLACEMENT_BOARD_PLACEMENT = 'placement_board_placement';
